import { render, staticRenderFns } from "./ManualLicitacaoServidor.vue?vue&type=template&id=596112eb&scoped=true"
import script from "./ManualLicitacaoServidor.vue?vue&type=script&lang=js"
export * from "./ManualLicitacaoServidor.vue?vue&type=script&lang=js"
import style0 from "./ManualLicitacaoServidor.vue?vue&type=style&index=0&id=596112eb&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596112eb",
  null
  
)

export default component.exports